import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/settings/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$companyId/spaces/$spaceId/settings/api-management',
      params,
      replace: true,
    })
  },
})
